import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { Utils } from '@shared/utils/utils';

export interface ForecastState {
  activitiesByDriver: {
    [k in 'Patient' | 'Site' | 'Time']: { cost: number; costStr: string; percentage: number };
  };
  hasCustomCurves: boolean;
  hasPatientCurves: boolean;
  hasSiteCurves: boolean;
  unforecastedCosts: number;
}

export function createInitialState(): ForecastState {
  return {
    activitiesByDriver: {
      Patient: { cost: 0, costStr: Utils.zeroHyphen, percentage: 0 },
      Site: { cost: 0, costStr: Utils.zeroHyphen, percentage: 0 },
      Time: { cost: 0, costStr: Utils.zeroHyphen, percentage: 0 },
    },
    hasCustomCurves: false,
    hasPatientCurves: false,
    hasSiteCurves: false,
    unforecastedCosts: 0,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'forecast' })
export class ForecastStore extends Store<ForecastState> {
  constructor() {
    super(createInitialState());
  }
}
